import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import BottomNavigation from './BottomNavigation'
import DesktopNavigation from './DesktopNavigation'
import useBreakpoint from '../hooks/useBreakpoint'
import useTelegramBackButton from '../hooks/useTelegramBackButton'
import useAppStore from '../store/useAppStore'
import { LANGUAGE_OPTIONS } from '../i18n/config'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { LOGO_SRC } from '../config/brand'

const Layout = () => {
  const location = useLocation()
  const isDesktop = useBreakpoint('(min-width: 1024px)')
  const { i18n, t } = useTranslation()
  const { isGuest, language, changeLanguage, openLogin } = useAppStore((state) => ({
    isGuest: state.isGuest,
    language: state.language,
    changeLanguage: state.changeLanguage,
    openLogin: state.openLogin
  }))

  const selectedLanguage = LANGUAGE_OPTIONS.find(({ code }) => code === language) || LANGUAGE_OPTIONS[0]

  // Интеграция кнопки "Назад" в Telegram
  useTelegramBackButton()

  // Hide navigation on case opening pages and on the mobile upgrader
  const hideNavigation = location.pathname.includes('/opening') ||
                         location.pathname.includes('/battles/create') ||
                         (location.pathname === '/upgrader' && !isDesktop)

  const contentWrapperClassName = isDesktop ? 'w-full max-w-screen-xl mx-auto relative' : 'w-full max-w-[600px] mx-auto relative'
  const mainPaddingClassName = hideNavigation ? '' : isDesktop ? 'pb-8' : 'pb-20'

  return (
    <div className="min-h-screen flex flex-col">
      {!hideNavigation && isDesktop && <DesktopNavigation />}
      {isGuest && !isDesktop && (
        <header className="flex items-center justify-between gap-2 px-4 py-3">
          <Link to="/" className="shrink-0" aria-label="SKINOZ"><img src={LOGO_SRC} alt="SKINOZ" className="w-28" /></Link>
          <div className="flex items-center gap-2">
            <div className="relative flex shrink-0 items-center gap-1.5 rounded-lg bg-surface p-2 text-xs text-white focus-within:ring-1 focus-within:ring-accent-primary">
              <img
                key={language}
                src={`https://flagcdn.com/${selectedLanguage.country}.svg`}
                alt=""
                aria-hidden="true"
                onError={(event) => { event.currentTarget.style.display = 'none' }}
                className="pointer-events-none w-4 shrink-0 rounded-[3px] border border-white/20"
              />
              <span aria-hidden="true" className="whitespace-nowrap">{selectedLanguage.name}</span>
              <select value={language} onChange={(event) => changeLanguage(event.target.value, i18n.changeLanguage)} aria-label={t('guest.language')} className="absolute inset-0 h-full w-full cursor-pointer opacity-0">
                {LANGUAGE_OPTIONS.map(({ code, name }) => <option key={code} value={code}>{name}</option>)}
              </select>
            </div>
            <button type="button" onClick={openLogin} className="rounded-lg bg-accent-primary px-3 py-2 text-xs font-bold text-dark-primary">{t('guest.login')}</button>
          </div>
        </header>
      )}
      
      {/* Wrapper для ограничения ширины только на мобильных экранах */}
      <div className={contentWrapperClassName}>
        {/* Main Content */}
        <main className={`flex-1 ${mainPaddingClassName}`}>
          <Outlet />
        </main>

        {/* Нижняя навигация показывается только на мобильных экранах */}
        {!hideNavigation && !isDesktop && <BottomNavigation />}
      </div>
    </div>
  )
}

export default Layout
